import { CountryCode } from '@yuno/sdk-web-core/dist/types'

export const SDK = {
  checkoutSession: 'fc3e69c3-e6a9-455b-a94b-9878b30abd57',
  customerSession: '55d33c4c-9541-4e9a-9e02-ca8c3dead373',
  countryCode: CountryCode.COLOMBIA,
  publicApiKey:
    'sandbox_gAAAAABi9jUBAeYzjG2HuHfzXTxfQNl8_9ign-NSKOS5_YnYVNbEdiP9_EDUYXSkSpIG7IRyUILF-KBeJEsg_OWgbnTruJnkMHfXdqFekTmwhkSyVPihy653U6dDk-zh_NMRnXyaPO0uT6HC5jmXr6VMl6HOknBcQPQI2j7H7cNpJsTWiS932MQ=',
  language: 'EN',
}

export const SDK_PAYMENT = {
  checkoutSession: SDK.checkoutSession,
  countryCode: SDK.countryCode,
  publicApiKey: SDK.publicApiKey,
  language: SDK.language,
}

export const SDK_ENROLLMENT = {
  customerSession: SDK.customerSession,
  countryCode: SDK.countryCode,
  publicApiKey: SDK.publicApiKey,
  language: SDK.language,
}
